import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import Card from '../ui/Card';

interface SalesFiltersProps {
  filters: {
    startDate: string;
    endDate: string;
    minAmount: string;
    maxAmount: string;
    vendorId: string;
  };
  onFilterChange: (name: string, value: string) => void;
}

const SalesFilters: React.FC<SalesFiltersProps> = ({ filters, onFilterChange }) => {
  const { vendors } = useSelector((state: RootState) => state.vendors);
  const { t } = useTranslation();

  return (
    <Card>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            {t('sales.dateRange')}
          </label>
          <div className="grid grid-cols-1 gap-6">
            <input
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={(e) => onFilterChange('startDate', e.target.value)}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
              placeholder={t('reports.startDate')}
            />
            <input
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={(e) => onFilterChange('endDate', e.target.value)}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
              placeholder={t('reports.endDate')}
            />
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            {t('sales.amountRange')}
          </label>
          <div className="grid grid-cols-2 gap-2">
            <input
              type="number"
              name="minAmount"
              placeholder={t('common.min')}
              value={filters.minAmount}
              onChange={(e) => onFilterChange('minAmount', e.target.value)}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
            />
            <input
              type="number"
              name="maxAmount"
              placeholder={t('common.max')}
              value={filters.maxAmount}
              onChange={(e) => onFilterChange('maxAmount', e.target.value)}
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            {t('sales.vendor')}
          </label>
          <select
            name="vendorId"
            value={filters.vendorId}
            onChange={(e) => onFilterChange('vendorId', e.target.value)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
          >
            <option value="">{t('sales.allVendors')}</option>
            {vendors.map(vendor => (
              <option key={vendor.id} value={vendor.id}>
                {vendor.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Card>
  );
};

export default SalesFilters;